import React from 'react';
import Loading from '../../img/loading.gif';

import '../../libs/bulma.min.css';
import './LoadingModule.css';

const LoadingModule = () => {
  return (
    <div className="loading-module-container">
      <div className="loading-module-content">
        <div className="loading-spinner-wrapper">
          <div className="spinner-vigos">
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <svg className="spinner-logo" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
        </div>
        <div className="loading-text">
          <h2>Carregando</h2>
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoadingModule;
